
import { Component, Vue, Watch } from 'vue-property-decorator'

@Component({
  layout: 'clean'
})
export default class ServiceAgreement extends Vue {
  iframeheight: string = '100vh'

  get iframeHeight() {
    return {
      height: this.iframeheight
    }
  }

  get htmlSrc() {
    return `${process.env.static}/protocol/user_pc.html?v=${process.env.version}`
  }

  jumpPage(e) {
    if (e.data.typeAction === 'jump') {
      this.$emit('turn-to-page', 'protocol-privacy')
    }

    if (e.data.typeAction === 'iframeHeight') {
      if (!e.data.height) return
      this.iframeheight = `${e.data.height}px`
    }
  }

  created() {
    window.addEventListener('message', this.jumpPage)
  }

  beforeDestroy() {
    window.removeEventListener('message', this.jumpPage)
  }
}
